import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import ChatWidget from './ChatWidget'; 
import LeadMagnetModal from './LeadMagnetModal'; 

function Layout() {
  const [showLeadModal, setShowLeadModal] = useState(false);
  // The chat and the lead popup used to fight: the popup trapped focus so
  // you could not type, while the chat's higher z-index hid the popup's
  // close button. They now take turns instead of overlapping.
  const [chatOpen, setChatOpen] = useState(false);
  const [leadModalOpen, setLeadModalOpen] = useState(false);

  return (
    <>
      <style>
        {`
          .get-help-btn {
            background-color: #c8102e;
            color: #fff !important;
            border-radius: 9999px;
            padding: 0.5rem 1.2rem;
            transition: all 0.2s ease;
            border: none;
            display: inline-block; 
            text-align: center;
            text-decoration: none;
            cursor: pointer;
          }
          .get-help-btn:hover {
            background-color: #e01a3b;
            color: #fff !important;
            transform: scale(1.05);
          }
        `}
      </style>

      <Navbar bg="white" expand="md" sticky="top" className="shadow-sm">
        <Container>
          <Link to="/">
            <img
              src="https://benignfasciculationsyndrome.org/assets/uploads/logo.png"
              alt="BFS Logo"
              style={{ height: '40px' }}
            />
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              <Nav.Link as={Link} to="/" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="me-3 fw-semibold" style={{ color: '#333' }}>
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/blog" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Blog
              </Nav.Link>
              <Nav.Link as={Link} to="/resources" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Resources
              </Nav.Link>
              <Nav.Link as={Link} to="/contact" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Contact
              </Nav.Link>
              <Nav.Link
                onClick={() => setShowLeadModal(true)}
                className="fw-bold get-help-btn ms-md-2"
              >
                Get Help
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Outlet />

      <div style={{ backgroundColor: '#222', color: '#fff', padding: '2rem 0', textAlign: 'center' }}>
        <Container>
          <p className="mb-1" style={{ fontSize: '1rem' }}>
            © {new Date().getFullYear()} BFS Organization. All rights reserved.
          </p>
          <p style={{ opacity: 0.8, fontSize: '1rem' }}>
            <em>Not medical advice. Always consult with a healthcare professional.</em>
          </p>
        </Container>
      </div>

      <ChatWidget onOpenChange={setChatOpen} hidden={leadModalOpen} />

      <LeadMagnetModal
        externalOpen={showLeadModal}
        onExternalClose={() => setShowLeadModal(false)}
        blocked={chatOpen}
        onOpenChange={setLeadModalOpen}
      />
    </>
  );
}

export default Layout;